import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {borderRadius, mt} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {ICreation} from "../types/ICreation";

interface IImageAdCreationProps {
    creation: IImageAdCreationData;
    url: string;
}

export type IImageAdCreationData = Pick<ICreation, "mobile_image" | "mobile_image_url">;

export const ImageAdCreation = (props: IImageAdCreationProps) => {
    const onImageAdCreationClick = () => window.open(props.url, "_blank");

    return (
        <ImageAdBoxBase onClick={onImageAdCreationClick}>
            <Image
                alt="creation"
                width="375"
                height="484"
                ratio={{xs: "366/442"}}
                src={getThumbnailLink(props.creation.mobile_image_url, 375, 484) ?? props.creation.mobile_image?.m_img_375x484}
                css={offerImage}
            />
            <ImageAdButton variant="stretched_primary" css={[mt(4)]}>
                Zobacz
            </ImageAdButton>
        </ImageAdBoxBase>
    );
};

const ImageAdBoxBase = styled(OfferBoxBase)`
    position: relative;
    height: 100%;
    margin: 0 auto;
`;

const ImageAdButton = styled(Button)`
    position: absolute;
    bottom: 0;
    left: 0;
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
    background-color: white;
    border-color: white;
`;

const offerImage = css`
    ${borderRadius(2)};
    cursor: pointer;
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {borderRadius, mt} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {ICreation} from "../types/ICreation";

interface IImageAdCreationProps {
    creation: IImageAdCreationData;
    url: string;
}

export type IImageAdCreationData = Pick<ICreation, "mobile_image" | "mobile_image_url">;

export const ImageAdCreation = (props: IImageAdCreationProps) => {
    const onImageAdCreationClick = () => window.open(props.url, "_blank");

    return (
        <ImageAdBoxBase onClick={onImageAdCreationClick}>
            <Image
                alt="creation"
                width="375"
                height="484"
                ratio={{xs: "366/442"}}
                src={getThumbnailLink(props.creation.mobile_image_url, 375, 484) ?? props.creation.mobile_image?.m_img_375x484}
                css={offerImage}
            />
            <ImageAdButton variant="stretched_primary" css={[mt(4)]}>
                Zobacz
            </ImageAdButton>
        </ImageAdBoxBase>
    );
};

const ImageAdBoxBase = styled(OfferBoxBase)`
    position: relative;
    height: 100%;
    margin: 0 auto;
`;

const ImageAdButton = styled(Button)`
    position: absolute;
    bottom: 0;
    left: 0;
    ${borderRadius(0, 0, 2, 2)}
    overflow: hidden;
    background-color: white;
    border-color: white;
`;

const offerImage = css`
    ${borderRadius(2)};
    cursor: pointer;
`;
